var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("매칭정보")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-data-table', _vm._b({
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.employee`,
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('v-layout', {
          attrs: {
            "column": "",
            "align-center": ""
          }
        }, [_c('span', {
          staticClass: "mb-4 mb-lg-8"
        }, [_vm._v(" " + _vm._s(value.info.name) + " ")]), _c('expo-employee-view', _vm._b({
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref3) {
              var attrs = _ref3.attrs,
                on = _ref3.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "outlined": "",
                  "width": "100",
                  "color": "grey-d"
                }
              }, 'v-btn', attrs, false), on), [_c('span', {
                staticClass: "grey--text"
              }, [_vm._v(" 지원정보 ")])])];
            }
          }], null, true)
        }, 'expo-employee-view', {
          _employee: value._id,
          _program: _vm._program
        }, false))], 1)];
      }
    }, {
      key: `item.employer`,
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('v-layout', {
          attrs: {
            "column": "",
            "align-center": ""
          }
        }, [_c('span', {
          staticClass: "mb-4 mb-lg-8"
        }, [_vm._v(" " + _vm._s(value.info.name) + " ")]), _c('v-btn', {
          attrs: {
            "small": "",
            "outlined": "",
            "width": "100",
            "color": "grey-d",
            "to": `/companies/${value._user}`
          }
        }, [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v(" 기업정보 ")])])], 1)];
      }
    }, {
      key: `item.meta`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('matching-meta', _vm._b({}, 'matching-meta', {
          item
        }, false))];
      }
    }, {
      key: `item.desc`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('matching-desc', _vm._b({}, 'matching-desc', {
          item,
          isUserEmployee: _vm.isUserEmployee,
          isUserEmployer: _vm.isUserEmployer
        }, false))];
      }
    }, {
      key: `item.state`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_c('expo-matching-state', _vm._b({}, 'expo-matching-state', {
          value: item,
          program: _vm.program,
          employee: item.employee,
          employer: item.employer,
          isUserHost: _vm.isUserHost,
          isUserEmployee: _vm.isUserEmployee,
          isUserEmployer: _vm.isUserEmployer
        }, false))];
      }
    }, {
      key: `item.grant`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_c('expo-matching-grant', _vm._b({
          on: {
            "input": _vm.pushMatchings
          }
        }, 'expo-matching-grant', {
          value: item,
          program: _vm.program,
          employee: item.employee,
          employer: item.employer,
          isUserHost: _vm.isUserHost,
          isUserEmployee: _vm.isUserEmployee,
          isUserEmployer: _vm.isUserEmployer
        }, false))];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider')];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    itemKey: '_id',
    itemsPerPage: -1,
    loading: _vm.loading
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }